import { Badge, Button } from '@e2n/ui/v2';
import { BerufeFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/BerufeFilter';
import { LehrjahrFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/LehrjahrFilter';
import { StandorteFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/StandorteFilter';
import { SortierungButton } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/SortierungButton.tsx';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { faFilter } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function KalenderViewOptions() {
  const { t } = useTranslation();
  const [filterOptionsVisible, setFilterOptionsVisible] = useState(false);
  const {
    store: {
      ui: {
        kalender: { filter },
      },
    },
  } = useRotationsplanFeatureContext();

  let selectedFilterCount = 0;
  Object.values(filter).forEach((filter) => {
    if (filter.length > 0) {
      selectedFilterCount += 1;
    }
  });

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <Button
          className="flex items-center gap-2"
          variant="ghost"
          onClick={() => setFilterOptionsVisible(!filterOptionsVisible)}>
          <FontAwesomeIcon className="size-4" icon={faFilter} />
          {t('domain.mitarbeiter.rotationsplan.filter.label')}
          <Badge className="bg-neutrals-v2-200 text-labels-primary">
            {selectedFilterCount}
          </Badge>
        </Button>
        <SortierungButton view="planung" variant="ghost" />
      </div>
      {filterOptionsVisible && (
        <div className="flex items-center gap-2">
          <BerufeFilter view="planung" variant="outline" />
          <LehrjahrFilter view="planung" variant="outline" />
          <StandorteFilter view="planung" variant="outline" />
        </div>
      )}
    </div>
  );
}
